import store from '@/store';
import { getCommonBookGray } from '@/api/order';

const grayCache = Object.create(null);
const grayRequestCache = Object.create(null);

/**
 * 按酒店缓存统一预订灰度，切换酒店后使用新的酒店编码重新查询。
 * 查询失败返回false但不缓存，使当前操作回退旧页面且后续操作仍可重新查询。
 * @returns {Promise<Boolean>} 当前登录酒店是否进入统一预订灰度
 */
export function queryCommonBookGray() {
  const hotelCode = store.getters.hotelCode || store.state.user.hotelCode;
  if (!hotelCode) return Promise.resolve(false);
  if (Object.prototype.hasOwnProperty.call(grayCache, hotelCode)) {
    return Promise.resolve(grayCache[hotelCode]);
  }
  if (grayRequestCache[hotelCode]) return grayRequestCache[hotelCode];
  grayRequestCache[hotelCode] = getCommonBookGray()
    .then((response) => {
      const enabled = response.code === '0' && response.data === true;
      grayCache[hotelCode] = enabled;
      return enabled;
    })
    .catch(() => {
      // 灰度查询失败时继续使用旧版预订，避免配置接口异常阻断酒店操作。
      return false;
    })
    .finally(() => {
      delete grayRequestCache[hotelCode];
    });
  return grayRequestCache[hotelCode];
}

/**
 * 清除指定酒店或全部酒店的前端灰度缓存，供登录酒店切换或配置刷新时使用。
 * @param {String} hotelCode 酒店编码；不传时清除全部缓存
 */
export function clearCommonBookGray(hotelCode) {
  if (hotelCode) {
    delete grayCache[hotelCode];
    delete grayRequestCache[hotelCode];
    return;
  }
  Object.keys(grayCache).forEach((key) => delete grayCache[key]);
  Object.keys(grayRequestCache).forEach((key) => delete grayRequestCache[key]);
}
